import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'

const Table = styled.table`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
`

const Field = styled.th`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  text-align: left;
`

const Data = styled.td`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  display: table-cell;
`

const DropdownWrapper = styled.div`
  width: 100px;
  height: 30px;
  border: 1px solid #ddd;
  border-radius: 4px;
  position: relative;
  background-color: ${props => (props.active ? '#d4d4d4' : '#007ffb')};
  color: ${props => (props.active ? '#000' : '#fff')};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 5px;
`

const DropdownBox = styled.div`
  position: absolute;
  width: 120%;
  top: calc(100% + 5px);
  left: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1;
  color: #000;

  #search {
    overflow-y: auto;
    max-height: 200px;
  }

  #item {
    padding: 2px 8px;
    flex-shrink: 0;
    font-size: 12px;

    &:hover {
      background-color: #f4f4f4;
      cursor: pointer;
    }
  }
`

const DropdwonSearch = styled.div`
  width: 100%;
  padding: 4px 8px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  font-size: 12px;

  input {
    width: 100%;
    border: none;
    outline: none;
  }
`

const TagWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 8px;
`

const TagItem = styled.div`
  padding: 4px;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #dc143c;
    color: #fff;
    cursor: pointer;
  }
`

const List = ({
  fieldList,
  dataList,
  clickE,
  isClick,
  setDatas,
  setPtag,
  isAssistant,
  assistantUpdate,
  assistantDelete,
  statusUpdate,
  isAssistantDev,
  assistantToLive,
  dropdown,
  setDropdown,
  tagList,
  tagSearch,
  setTagSearch,
  tagSearchResult,
  insertAssistantTag,
  deleteAssistantTag,
}) => {
  return (
    <Table>
      <tbody>
        <tr>
          {fieldList.map((field, index) => {
            return (
              field !== 'assistantInfo' && <Field key={index}>{field}</Field>
            )
          })}
        </tr>
        {dataList.map((data, index) => {
          let list = []

          for (const field of fieldList) {
            if (field === 'stickerImg') {
              list.push(
                <td key={field + index}>
                  <img src={data[field]} style={{ width: 100, height: 100 }} />
                </td>
              )
            } else if (field === 'profileImg') {
              list.push(
                <td key={field + index}>
                  <img src={data[field]} style={{ width: 100, height: 100 }} />
                </td>
              )
            } else if (field === 'nudity') {
              list.push(
                <td key={field + index}>
                  {data[field] ? data[field][0].type : null}
                </td>
              )
            } else if (field === 'assistantImg') {
              list.push(
                <td key={field + index}>
                  <img src={data[field]} style={{ width: 100, height: 100 }} />
                </td>
              )
            } else if (field === 'instructions') {
              list.push(
                <td
                  key={field + index}
                  style={{ maxWidth: 200, overflow: 'hidden' }}
                >
                  {data[field]}
                </td>
              )
            } else if (field === 'assistantStatus') {
              list.push(
                <Data
                  key={field + index}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  {data[field]}
                  <div style={{ display: 'flex' }}>
                    <button
                      onClick={() => statusUpdate(data['assistantId'], 'Y')}
                    >
                      활성화
                    </button>
                    <button
                      onClick={() => statusUpdate(data['assistantId'], 'N')}
                    >
                      비활성화
                    </button>
                  </div>
                </Data>
              )
            } else if (field === 'tags') {
              list.push(
                <Data key={field + index}>
                  {data[field] && (
                    <TagWrapper>
                      {data[field].map((tag, idx) => (
                        <TagItem
                          key={idx}
                          onClick={() =>
                            deleteAssistantTag([
                              { assistantId: data.assistantId, tagId: tag.id },
                            ])
                          }
                        >
                          {tag.name}
                        </TagItem>
                      ))}
                    </TagWrapper>
                  )}
                  <DropdownWrapper
                    active={dropdown === field + index}
                    onClick={() => {
                      setDropdown(
                        field + index === dropdown ? false : field + index
                      )
                    }}
                  >
                    {dropdown === field + index ? '취소' : '태그 추가'}
                    {dropdown === field + index && (
                      <DropdownBox
                        onClick={e => {
                          e.stopPropagation()
                          e.preventDefault()
                        }}
                      >
                        <DropdwonSearch>
                          <input
                            type="text"
                            placeholder="Search"
                            value={tagSearch}
                            onChange={e => setTagSearch(e.target.value)}
                            onClick={e => e.stopPropagation()}
                            autoFocus
                          />
                        </DropdwonSearch>
                        <div id="search">
                          {tagSearchResult.map((tag, idx) => (
                            <div
                              id="item"
                              key={tag.id || idx}
                              onClick={() => {
                                insertAssistantTag([
                                  {
                                    assistantId: data.assistantId,
                                    tagId: tag.id,
                                  },
                                ])
                              }}
                            >
                              {tag.tag} {tag.official === 'Y' ? '*' : ''}
                            </div>
                          ))}
                        </div>
                      </DropdownBox>
                    )}
                  </DropdownWrapper>
                </Data>
              )
            } else if (field !== 'assistantInfo') {
              if (field === 'assistantId') {
                list.push(
                  <>
                    <Data key={field + index}>
                      {data[field]}
                      <br />
                      <button
                        onClick={() => {
                          window.open(
                            `https://fan.stipop.ai/chat/${btoa(data[field])}`,
                            '_blank'
                          )
                        }}
                      >
                        이동
                      </button>
                    </Data>
                  </>
                )
              } else {
                list.push(
                  <Data key={field + index} onClick={() => {}}>
                    {data[field]}
                  </Data>
                )
              }
            }
          }

          if (isAssistant) {
            if (isAssistantDev) {
              list.push(
                <>
                  <td key={99999}>
                    <button onClick={() => assistantUpdate(data)}>수정</button>
                    <button onClick={() => assistantToLive(data)}>
                      Live 옮기기
                    </button>
                  </td>
                </>
              )
            } else {
              list.push(
                <>
                  <td key={99999}>
                    <button onClick={() => assistantUpdate(data)}>수정</button>
                    {/* <button onClick={() => toRoyalChat(data)}>To royal</button> */}
                  </td>
                </>
              )
            }
          }

          return <tr key={index}>{list}</tr>
        })}
      </tbody>
    </Table>
  )
}

export default List
